// removed by extract-text-webpack-plugin
module.exports = {"contentView":"_-src-components-UserSegment-index---contentView---25kop","userSegmentContent":"_-src-components-UserSegment-index---userSegmentContent---RZp_Z","loader":"_-src-components-UserSegment-index---loader---27KQq","content":"_-src-components-UserSegment-index---content---_LV0F","resrtrictionsTitle":"_-src-components-UserSegment-index---resrtrictionsTitle---33N_o","contentWrapper":"_-src-components-UserSegment-index---contentWrapper---23KlS","primaryContent":"_-src-components-UserSegment-index---primaryContent---1IfM9","description":"_-src-components-UserSegment-index---description---2e46g"};


//////////////////
// WEBPACK FOOTER
// ./src/components/UserSegment/index.css
// module id = 815
// module chunks = 1